module.exports = __webpack_public_path__ + "static/img/044 2.4fbb529a.jpg";